export default "__VITE_ASSET__B8FEq23l__"